import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FullFeedbackAlertType } from 'src/app/models/enums/full-feedback-alert-type';

export interface FullFeedbackAlertData {
  type: FullFeedbackAlertType;
  title: string;
  data?: any;
  messages: string[];
  error_msg?: string[];
  confirm?: boolean;
  positive?: string;
  positiveIcon?: string;
  negative?: string;
  negativeIcon?: string;
  requiredReason?: boolean;
}

@Component({
  selector: 'app-confirm-dialog-input',
  templateUrl: './confirm-dialog-input.component.html',
  styleUrls: ['./confirm-dialog-input.component.scss'],
})
export class ConfirmDialogInputComponent implements OnInit {
  descriprion: UntypedFormControl;

  readonly TYPE = FullFeedbackAlertType;
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FullFeedbackAlertData
  ) {
    this.descriprion = new UntypedFormControl(
      data?.data?.return_reason || '',
      data?.requiredReason ? [Validators.required] : []
    );
  }

  ngOnInit(): void {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.dialogRef.addPanelClass([
      'animate__animated',
      'animate__slideInUp',
      'animate__faster',
    ]);
    await this.dialogRef.beforeClosed().toPromise();
    this.dialogRef.removePanelClass([
      'animate__animated',
      'animate__slideInUp',
      'animate__faster',
    ]);
    this.dialogRef.addPanelClass([
      'animate__animated',
      'animate__fadeOutDown',
      'animate__faster',
    ]);
  }
}
